<div class="map home-block">
  <div class="home-container">
    <div id="map-and-img">
      <iframe
        allowfullscreen=""
        height="350"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15608.577943704136!2d20.139386836796696!3d46.24559906316355!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4744887a08556bb3%3A0x87091c298cd2a2b1!2zU1pURSBKw7N6c2VmIEF0dGlsYSBUYW51bG3DoW55aSDDqXMgSW5mb3Jtw6FjacOzcyBLw7Z6cG9udA!5e0!3m2!1shu!2sus!4v1724403230031!5m2!1shu!2sus"
        style="border: 0; filter: invert(1)"
        title="helyszín térkép"
        width="350"
      ></iframe>
      <img
        alt=""
        height="350"
        loading="lazy"
        src="/multimedia/home/szebit_round.webp"
        width="350"
      />
    </div>
  </div>
</div>
